<template>
  <div id="dashboard" class="bannerhome">
    <div class="">
      <div class="row">
        <div class="col-lg-6 pb-0">
          <img
            src="../assets/imgs/sorteocch/bg-inteior-mobile.jpg"
            alt="Troka"
            class="w-100 d-block d-lg-none"
          />
        </div>

        <div class="col-lg-5 py-5 my-5 pb-0d">
          <div class="bgazul borderrounded p-lg-4">
            <p class="fXG text-center bold pb-4 azul pt-lg-5 mt-lg-4 pt-md-0">
              ¡Hola
              <span class="azul">{{ userProfile.nombre }}</span
              >!
            </p>

            <p class="fG text-center black">
              Para comenzar sube una foto de tu <b>Ticket de compra</b> e
              ingresa los datos:
            </p>

            <div class="row">
              <div
                class="col-12 text-center d-flex justify-content-center align-items-center"
              >
                <input
                  type="file"
                  class="hidden"
                  ref="file"
                  @change="fileSelected"
                  accept="image/*"
                  capture
                />
              </div>

              <div class="col-12 py-2">
                <div class="px-2 row">
                  <form class="col-12 text-left">
                    <div class="row">
                      <div class="col-12 pb-3">
                        <div class="row">
                          <!-- <div class="col-12 fG bold pb-2 azul">
                      
                      <span class="iconoinfo" @click="toggleInfoMonto()">
                        <svg
                          height="24"
                          viewBox="0 0 48 48"
                          width="24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M22 34h4v-12h-4v12zm2-30c-11.05 0-20 8.95-20 20s8.95 20 20 20 20-8.95 20-20-8.95-20-20-20zm0 36c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16zm-2-22h4v-4h-4v4z"
                          />
                        </svg>
                      </span>
                    </div> -->

                          <!-- <div class="col-12 text-center" v-show="info_monto">
                      <img
                        class="img-fluid"
                        src="../assets/imgs/viaja/interior/ticket_sumar_monto.png"
                        alt="Verano con sabor a cinepolis"
                      />
                    </div> -->
                        </div>
                        <!-- <label class="px-2">
                    <input
                      type="number"
                      required
                      v-model="monto"
                      placeholder="Monto de compra en productos"
                    />
                  </label> -->
                      </div>
                      <!-- <div class="col-12">
                  <div class="row fG bold pb-2 azul">
                    <div class="col-12">
                      No. de Ticket

                      <span class="iconoinfo" @click="toggleInfoTicket()">
                        <svg
                          height="24"
                          viewBox="0 0 48 48"
                          width="24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M22 34h4v-12h-4v12zm2-30c-11.05 0-20 8.95-20 20s8.95 20 20 20 20-8.95 20-20-8.95-20-20-20zm0 36c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16zm-2-22h4v-4h-4v4z"
                          />
                        </svg>
                      </span>
                    </div>
                    <div class="col-12 text-center" v-show="info_ticket">
                      <img
                        class="img-fluid"
                        src="../assets/imgs/viaja/interior/ticket_numero_de_ticket.png"
                        alt="Verano con sabor a cinepolis"
                      />
                    </div>
                  </div>
                  <label class="px-2">
                    <input
                      type="text"
                      required
                      v-model="no_ticket"
                      placeholder="No. de Ticket"
                      maxlength="30"
                    />
                  </label>
                </div> -->
                    </div>
                  </form>
                </div>
              </div>

              <!-- <div class="col-12 pb-3 px-5 text-center">
              <span class="fG black"
                >Recuerda que solo participan tickets de compra que hayan sido
                emitidos durante la vigencia de la promoción.</span
              >
            </div> -->

              <div class="w-100 text-center pr-lg-4">
                <div
                  class="px-2 text-center d-inline-block align-items-center pb-5"
                >
                  <button
                    @click="$refs.file.click()"
                    class="btnaction pointer d-inline-block align-items-center justify-content-center fG"
                  >
                    Subir foto
                  </button>
                </div>

                <div class="py-2">
                  <div id="preview"></div>
                </div>

                <div class="col-12 pb-0 px-5">
                  <form action @submit.prevent>
                    <label for class="py-4">
                      <span class="mb-3 fG d-block azul"
                        >Ingresa los datos de tu ticket:</span
                      >

                      <select
                        class="mb-4"
                        v-model="cadena"
                        v-if="cadenas != null"
                        @change="getSucursales()"
                      >
                        <option value="" hidden>
                          Selecciona una cadena...
                        </option>
                        <option
                          :value="item.cadena"
                          v-for="(item, index) in cadenas"
                          :key="index"
                        >
                          {{ item.cadena }}
                        </option>
                      </select>

                      <select
                        class="mb-4"
                        v-model="sucursal"
                        v-if="cadena != ''"
                        @change="getInfoSucursal()"
                      >
                        <option value="" hidden>
                          Selecciona una sucursal...
                        </option>
                        <option
                          :value="item.sucursal"
                          v-for="(item, index) in sucursales"
                          :key="index"
                        >
                          {{ item.sucursal }}
                        </option>
                      </select>

                      <input
                        type="text"
                        :value="sucursal_escrito"
                        @input="
                          sucursal_escrito = $event.target.value.toUpperCase()
                        "
                        required
                        v-if="sucursal == 'OTRO'"
                        maxlength="250"
                        placeholder="Escribe el nombre de la sucursal..."
                      />

                      <select
                        class="mb-4"
                        v-model="vendedor"
                        v-if="sucursal != '' && sucursal != 'OTRO'"
                      >
                        <option value="" hidden>
                          Selecciona un vendedor...
                        </option>
                        <option
                          :value="item.vendedor"
                          v-for="(item, index) in vendedores"
                          :key="index"
                        >
                          {{ item.vendedor }}
                        </option>
                        <option value="OTRO">OTRO</option>
                      </select>

                      <input
                        type="text"
                        :value="vendedor_escrito"
                        @input="
                          vendedor_escrito = $event.target.value.toUpperCase()
                        "
                        required
                        v-if="vendedor == 'OTRO' || sucursal == 'OTRO'"
                        maxlength="250"
                        placeholder="Escribe el nombre del vendedor..."
                      />

                      <select
                        class="mb-4"
                        v-model="producto"
                        v-if="sucursal != ''"
                      >
                        <option value="" hidden>
                          Selecciona un producto...
                        </option>
                        <option value="CEMENTO GRIS">CEMENTO GRIS</option>
                        <option value="CEMENTO BLANCO">CEMENTO BLANCO</option>

                        <!-- <option
                        :value="item.producto"
                        v-for="(item, index) in productos"
                        :key="index"
                      >
                        {{ item.producto }}
                      </option> -->
                      </select>

                      <select class="mb-4" v-model="peso" v-if="sucursal != ''">
                        <option value="" hidden>Selecciona un peso...</option>
                        <option value="25KG">25KG</option>
                        <option value="50KG">50KG</option>
                        <!-- <option
                        :value="item.peso"
                        v-for="(item, index) in pesos"
                        :key="index"
                      >
                        {{ item.peso }}
                      </option> -->
                      </select>
                    </label>
                  </form>
                </div>

                <div class="col-12 pb-5 mb-5" v-if="file != null">
                  <div class="px-2 text-center d-flex align-items-center">
                    <button
                      @click="tomarParticipacion()"
                      class="btnaction pointer d-inline-block align-items-center justify-content-center fG ml-auto mr-auto"
                    >
                      Enviar datos
                    </button>
                  </div>
                </div>

                <div class="col-12">
                  <p class="fG text-center black">
                    Consulta tus participaciones
                  </p>

                  <div class="text-center pb-5">
                    <router-link
                      to="/mis-participaciones"
                      class="pointer d-inline-block align-items-center justify-content-center fG ml-auto mr-auto btnaction"
                    >
                      Consultar
                    </router-link>
                  </div>
                </div>

                <div class="col-12 pt-5">
                  <!-- <p class="text-center bold grisoscuro">
                  Promoción vigente del 15 de mayo de 2023 al 09 de julio de
                  2023.
                </p> -->
                  <p class="text-center fG">
                    Dudas o información de la promoción comunícate al 55 9435
                    6588
                    <!-- de lunes a viernes de 09:00 a 18:00 hrs. -->
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer></Footer>

    <div
      class="overlayticket overlay-sucursal"
      v-if="overlay_sucursal === true"
    >
      <div class="bg-overlay" @click="toggleSucursal"></div>
      <div class="ticket shadow rounded bg-moradooscuro">
        <div class="head">
          <div
            class="cerrar p-2 d-block fG pointer amarillo monts"
            @click="toggleSucursal"
          >
            cerrar
          </div>
        </div>
        <div class="body text-center w-100"></div>
      </div>
    </div>

    <div
      class="overlayticket overlay-sucursal"
      v-if="overlay_transaccion === true"
    >
      <div class="bg-overlay" @click="toggleTransaccion"></div>
      <div class="ticket shadow rounded bg-moradooscuro">
        <div class="head">
          <span
            class="cerrar p-2 d-block fG pointer amarillo monts"
            @click="toggleTransaccion"
            >cerrar</span
          >
        </div>
        <div class="body text-center w-100">
          <div class="titulo fG amarillo bold">Número de transacción:</div>
          <img
            class="img-fluid p-4"
            src="../assets/imgs/homeins/ticket-transaccion.jpg"
            alt="Verano con sabor a cinepolis"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commentsCollection, ticketsCollection } from "@/firebase";
import { mapState } from "vuex";
import moment from "moment";
import AOS from "aos";
import swal from "sweetalert2";

import * as fb from "../firebase";

import Footer from "@/components/Footer";

export default {
  components: {
    Footer,
  },
  data() {
    return {
      post: {
        content: "",
      },
      showCommentModal: false,
      selectedPost: {},
      showPostModal: false,
      fullPost: {},
      postComments: [],
      file: null,
      file2: null,
      file3: null,
      no_ticket: "",
      monto: null,
      no_membresia_plus: "",
      monto_minimo: 100,
      monedero: "",
      no_transaccion: null,
      no_sucursal: null,
      disponibles: [],
      overlay_transaccion: false,
      overlay_sucursal: false,
      info_monto: false,
      info_ticket: false,
      socio_plus: false,
      tickets3: null,
      ultimo_ticket: {
        puntos: "",
        time: "",
        time_txt: "",
      },
      tokens_disponibles: 0,
      cadenas: [],
      sucursales: [],
      vendedores: [],
      productos: [],
      pesos: [],
      cadena: "",
      sucursal: "",
      sucursal_escrito: "",
      vendedor: "",
      vendedor_escrito: "",
      producto: "",
      peso: "",
      cantidad: 0,
      sucursal_envio: "",
      vendedor_envio: "",
      boleto: "",
    };
  },
  computed: {
    ...mapState(["userProfile", "posts"]),
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation,
      disable: "mobile",
    });

    this.getCadenas();

    //this.getTickets2();
  },
  methods: {
    // async jugar() {
    //   this.$store.commit(
    //     "setTicketID",
    //     this.userProfile.ultimo_ticket_registrado
    //   );
    //   this.$router.push("/dinamica");
    // },
    getCadenas() {
      const https = require("https");
      var qData = {
        //img_url: ticket_obj.ticket_img_url,
      };
      this.$http
        .post(process.env.VUE_APP_API_URL + "getC.php", JSON.stringify(qData), {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "text/plain",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          async (response) => {
            // get body data
            console.log("VERYFI RESPONSE");
            console.log(response);

            let res = response.body;
            console.log({ res });
            if (res.status === "ok") {
              this.cadenas = res.datos;
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            swal.fire(
              "Oops",
              "Hubo un error al momento de comunicarse con el servidor, por favor intenta de nuevo.",
              "warning"
            );
            this.$store.dispatch("showLoader", false);
          }
        );
    },
    getSucursales() {
      console.log("getting sucursales");

      const https = require("https");
      var qData = {
        cadena: this.cadena,
      };
      this.$http
        .post(process.env.VUE_APP_API_URL + "getS.php", JSON.stringify(qData), {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "text/plain",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          async (response) => {
            // get body data
            console.log("VERYFI RESPONSE");
            console.log(response);

            let res = response.body;
            console.log({ res });
            if (res.status === "ok") {
              this.sucursales = res.datos;
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            swal.fire(
              "Oops",
              "Hubo un error al momento de comunicarse con el servidor, por favor intenta de nuevo.",
              "warning"
            );
            this.$store.dispatch("showLoader", false);
          }
        );
    },
    getInfoSucursal() {
      console.log("getting sucursales");

      const https = require("https");
      var qData = {
        cadena: this.cadena,
        sucursal: this.sucursal,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getInfo2.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            console.log("VERYFI RESPONSE");
            console.log(response);

            let res = response.body;
            console.log({ res });
            if (res.status === "ok") {
              this.vendedores = res.vendedores;
              this.productos = res.productos;
              this.pesos = res.pesos;
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            swal.fire(
              "Oops",
              "Hubo un error al momento de comunicarse con el servidor, por favor intenta de nuevo.",
              "warning"
            );
            this.$store.dispatch("showLoader", false);
          }
        );
    },
    async getTickets2() {
      const docs = await ticketsCollection
        .where("user_id", "==", fb.auth.currentUser.uid)
        .where("status_juego", "==", "jugando")
        .get();

      this.tickets3 = [];
      docs.forEach((doc) => {
        let ticket = doc.data();
        ticket.id = doc.id;
        this.tickets3.push(ticket);

        this.tokens_disponibles += ticket.tokens_disponibles;
      });

      console.log({ tickets3: this.tickets3 });
    },

    toggleInfoMonto() {
      this.info_monto = !this.info_monto;
    },
    toggleInfoTicket() {
      this.info_ticket = !this.info_ticket;
    },
    fileSelected: function ($event) {
      this.file = $event.target.files[0];

      var reader = new FileReader();

      reader.onload = function (e) {
        // get loaded data and render thumbnail.
        var preview = document.getElementById("preview");
        var image = document.createElement("img");
        image.src = e.target.result;
        preview.innerHTML = "";
        preview.appendChild(image);
        console.log(preview);

        swal.fire(
          "Bien",
          "Recuerda conservar tus tickets de compra.",
          "warning"
        );
      };

      // read the image file as a data URL.
      reader.readAsDataURL(this.file);
    },
    fileSelected2: function ($event) {
      this.file2 = $event.target.files[0];

      var reader = new FileReader();

      reader.onload = function (e) {
        // get loaded data and render thumbnail.
        var preview = document.getElementById("preview2");
        var image = document.createElement("img");
        image.src = e.target.result;
        preview.innerHTML = "";
        preview.appendChild(image);
        console.log(preview);
      };

      // read the image file as a data URL.
      reader.readAsDataURL(this.file2);
    },
    fileSelected3: function ($event) {
      this.file3 = $event.target.files[0];

      var reader = new FileReader();

      reader.onload = function (e) {
        // get loaded data and render thumbnail.
        var preview = document.getElementById("preview3");
        var image = document.createElement("img");
        image.src = e.target.result;
        preview.innerHTML = "";
        preview.appendChild(image);
        console.log(preview);
      };

      // read the image file as a data URL.
      reader.readAsDataURL(this.file3);
    },
    async tomarParticipacion() {
      if (this.file == null) {
        swal.fire(
          "Oops",
          "Sube la foto de un ticket antes de continuar...",
          "info"
        );
        return;
      }

      if (
        this.userProfile.user_id == "" ||
        this.userProfile.user_id == undefined ||
        this.userProfile.user_id == null
      ) {
        swal.fire(
          "Oops",
          "Ha ocurrido un error en el envío de tu respuesta, por favor recarga la página y vuelve a intentarlo.",
          "warning"
        );
        return;
      }

      this.sucursal_envio = this.sucursal;
      this.vendedor_envio = this.vendedor;
      if (this.sucursal == "OTRO") {
        this.sucursal_envio = this.sucursal_escrito;
        this.vendedor_envio = this.vendedor_escrito;
      }
      if (this.vendedor == "OTRO") {
        this.vendedor_envio = this.vendedor_escrito;
      }

      if (
        this.sucursal_envio == "" ||
        this.vendedor_envio == "" ||
        this.producto == "" ||
        this.peso == ""
      ) {
        swal.fire(
          "Oops",
          "Ingresa los datos solicitados del ticket antes de continuar...",
          "info"
        );
        return;
      }

      //await this.getBoleto(this.userProfile.user_id);

      let ticket_obj = await this.$store.dispatch("registroTicket", {
        file: this.file,
        cadena: this.cadena,
        sucursal: this.sucursal_envio,
        vendedor: this.vendedor_envio,
        producto: this.producto,
        peso: this.peso,
        boleto: "pendiente",
      });

      this.uploadVeryfi(ticket_obj);
    },
    async getBoleto(ticket_obj) {
      const https = require("https");
      const firebaseUserUid = ticket_obj.user_id || "";
      const firebaseUserEmail = ticket_obj.user_email || "";
      var qData = {
        firebase_ticket_id: ticket_obj.id,
        firebase_ticket_uid: ticket_obj.id,
        user_id: firebaseUserUid,
        firebase_user_uid: firebaseUserUid,
        email: firebaseUserEmail,
        user_email: firebaseUserEmail,
        source: "dashboard_ticket_obj",
        cadena: this.cadena,
        sucursal: this.sucursal_envio,
        vendedor: this.vendedor_envio,
        producto: this.producto,
        peso: this.peso,
      };

      const response = await this.$http.post(
        process.env.VUE_APP_API_URL + "getBo.php",
        JSON.stringify(qData),
        {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "text/plain",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          }
        }
      );

      console.log("bo RESPONSE");
      console.log(response);

      let res = response.body;
      if (res.status !== "ok" || !res.boleto) {
        throw new Error(res.msg || "No se pudo generar el boleto");
      }

      this.boleto = res.boleto;

      this.file = null;
      var preview = document.getElementById("preview");
      preview.innerHTML = "";

      return res.boleto;
    },
    uploadVeryfi(ticket_obj) {
      const https = require("https");
      var qData = {
        img_url: ticket_obj.ticket_img_url,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "main2.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            console.log("VERYFI RESPONSE");
            console.log(response);

            let res = response.body;
            let boleto = "pendiente";

            if (res.validacion === "valido") {
              try {
                boleto = await this.getBoleto(ticket_obj);
              } catch (error) {
                console.log("error callback");
                console.log(error);
                swal.fire(
                  "Oops",
                  "Hubo un error al momento de generar el boleto, por favor intenta de nuevo.",
                  "warning"
                );
                this.$store.dispatch("showLoader", false);
                return;
              }
            }

            let resactualiza = await this.$store.dispatch(
              "actualizaTicketVeryfi",
              {
                ticket_ocr: res.response,
                ticket_obj: ticket_obj,
                validacion: res.validacion,
                boleto: boleto,
                //validacion_cementos: '',
                validacion_fecha: res.validacion_fecha,
                invoice_duplicado: res.invoice_duplicado,

                //coca_sin_azucar: res.coca_sin_azucar,
                //cashi: res.cashi,
                //socio_plus: this.socio_plus,
              }
            );

            if (resactualiza === "ok") {
              swal
                .fire({
                  title: "Ticket enviado",
                  text: "Validaremos tu ticket en un lapso de 72 hrs.",
                  icon: "success",
                  confirmButtonText: "Continuar",
                })
                .then((result) => {
                  this.$router.push("/mis-participaciones/");
                });
            } else {
              swal.fire(
                "Oops",
                "El ticket que has registrado es inválido, verifica los datos de tu ticket e intenta subirlo nuevamente, la foto debe ser nítida y contener el ticket completo no. de ticket, fecha y productos participantes.",
                "warning"
              );
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            swal.fire(
              "Oops",
              "Hubo un error al momento de subir tu ticket, por favor intenta de nuevo.",
              "warning"
            );
            this.$store.dispatch("showLoader", false);
          }
        );
    },
    generateRandomNumber() {
      const randomNumber =
        Math.floor(Math.random() * (99999 - 10000 + 1)) + 10000;
      console.log(randomNumber);
      return randomNumber;
    },
    toggleSucursal() {
      this.overlay_sucursal = !this.overlay_sucursal;
    },
    toggleTransaccion() {
      this.overlay_transaccion = !this.overlay_transaccion;
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }

      let date = val.toDate();
      return moment(date).fromNow();
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    },
  },
};
</script>

<style lang="scss" scoped>
.overlayticket {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100000;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  .bg-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -1;
  }
  .ticket {
    width: 50%;
    margin: 0 25%;
    .head {
      width: 100%;
      .cerrar {
        text-align: right;
        cursor: pointer;
        user-select: none;
      }
    }
    .body {
    }
  }
}
</style>
